
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'CancelAcceptedAnnual',
    props: {
        periodEndLabel: { type: String, default: '' },
        // What Stripe reported after the coupon was applied (coupon name or percent).
        discountLabel: { type: String, default: '' },
        // Which annual offer was claimed, e.g. "3 months free" or "50% off your next year".
        offerLabel: { type: String, default: 'your retention discount' },
    },
    emits: ['done'],
});
